module.exports = __webpack_public_path__ + "img/newsImg6-7.5577803e.png";